<ng-template #payoutView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div>
            <div class="card-title">
                <h2>{{ 'MODALS.HEADERS.PAYOUT' | translate }}</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-4">
                        <label for="walletTotal">{{ 'MODALS.FIELDS.SUM' | translate }}</label>
                        <input #inputTotal class="form-control form-control-lg" id="walletTotal">
                    </div>
                    <div class="col-8">
                        <label for="bankAccount">{{ 'MODALS.FIELDS.TRANSFER' | translate }}</label>
                        <input #inputBank class="form-control form-control-lg" id="bankAccount">
                    </div>
                </div>
                <button (click)="onPayoutEvent(inputTotal, inputBank, modal)"
                        [disabled]="isLockButton"
                        class="btn btn-primary btn-lg btn-block m-2"
                        data-action="createPayout"
                        type="submit">
                    <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.EXECUTE_TRANSACTION' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
